import React from "react";
import { FieldArray, ErrorMessage } from "formik";
import { Grid, Box, Typography, IconButton, Chip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";

const checkDimensions = (file) =>
    new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => { 
            // Allow dimensions 800x400 or lower
            // if (img.width <= 800 && img.height <= 400) {
            //     resolve(true); // Dimensions are valid
            // } else {
            //     resolve(false); // Dimensions are invalid
            // }
            resolve(true);
        };

        img.onerror = () => {
            reject(new Error("Failed to load the image."));
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result; // Load the image
        };

        reader.onerror = () => {
            reject(new Error("Failed to read the file."));
        };

        reader.readAsDataURL(file);
    });

export default function StepSeven({ values, setFieldValue, touched, errors }) {
    const [errorTexts, setErrorTexts] = React.useState({});
    const [previews, setPreviews] = React.useState({
        uploadedFile: [],
        signature: null,
    }); 

    // Sync preview for signature when values.signature is a string (path)
    React.useEffect(() => {
        if (values && values.signature && typeof values.signature === 'string') {
            setPreviews((prev) => ({ ...prev, signature: values.signature }));
        }
    }, [values && values.signature]);

    // Validate file type - only allow images
    const isValidImageFile = (file) => {
        const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        return validImageTypes.includes(file.type);
    };

    // Show preview and allow removal for uploaded files
    const handleFileUpload = async (event, index) => {
        const file = event.currentTarget.files[0]; 
        
        if (!file) return;

        // Validate file type
        if (!isValidImageFile(file)) {
            toast.error("Please upload only image files (JPEG, PNG, GIF, WebP)");
            event.target.value = null; // Reset the file input
            return;
        }

        const updatedErrorTexts = { ...errorTexts };
        const updatedPreviews = { ...previews };

        try {
            updatedErrorTexts[index] = null;
            const updatedFiles = [...values.uploadedFile];
            updatedFiles[index] = file;
            setFieldValue("uploadedFile", updatedFiles);

            // Generate a preview
            const reader = new FileReader();
            reader.onload = (e) => {
                updatedPreviews.uploadedFile[index] = e.target.result;
                setPreviews({ ...updatedPreviews });
            };
            reader.readAsDataURL(file);
        } catch (error) {
            updatedErrorTexts[index] = "Failed to load the image.";
            event.target.value = null; // Reset the file input
            setFieldValue(`uploadedFile[${index}]`, null);
            updatedPreviews.uploadedFile[index] = null;
            toast.error("Failed to process the image file");
        }

        setErrorTexts(updatedErrorTexts);
    };

    // Remove file and preview only (don't delete the field)
    const handleRemoveFilePreview = (index) => {
        const updatedPreviews = { ...previews };
        updatedPreviews.uploadedFile[index] = null;
        setPreviews(updatedPreviews);
        
        const updatedFiles = [...values.uploadedFile];
        updatedFiles[index] = null;
        setFieldValue("uploadedFile", updatedFiles);
        
        // Reset the file input
        const fileInput = document.querySelectorAll('input[type="file"]')[index];
        if (fileInput) {
            fileInput.value = '';
        }
    };

    // Remove entire field
    const handleRemoveField = (index, arrayHelpers) => {
        const updatedPreviews = { ...previews };
        updatedPreviews.uploadedFile.splice(index, 1);
        setPreviews(updatedPreviews);
        arrayHelpers.remove(index);
    };

    const handleSignatureUpload = (event) => {
        const file = event.currentTarget.files[0];
        
        if (!file) return;

        // Validate file type for signature
        if (!isValidImageFile(file)) {
            toast.error("Please upload only image files (JPEG, PNG, GIF, WebP) for signature");
            event.target.value = null; // Reset the file input
            return;
        }

        const updatedPreviews = { ...previews };

        try {
            const reader = new FileReader();
            reader.onload = (e) => {
                updatedPreviews.signature = e.target.result;
                setPreviews({ ...updatedPreviews });
            };
            reader.readAsDataURL(file);
            setFieldValue("signature", file);
        } catch (error) {
            toast.error("Failed to process the signature image");
            event.target.value = null;
            updatedPreviews.signature = null;
            setPreviews({ ...updatedPreviews });
            setFieldValue("signature", null);
        }
    };

    // Remove signature
    const handleRemoveSignature = () => {
        setPreviews((prev) => ({ ...prev, signature: null }));
        setFieldValue("signature", null);
        
        // Reset the signature file input
        const signatureInputs = document.querySelectorAll('input[type="file"]');
        const signatureInput = signatureInputs[signatureInputs.length - 1]; // Last file input is signature
        if (signatureInput) {
            signatureInput.value = '';
        }
    };

    return (
        <>
            <div className="card stepCard">
                <Box className="card-body" sx={{ padding: "15px" }}>
                    <Grid container spacing={2}>
                        <Grid item md={12} xs={12}>
                            <Box className="commonBox">
                                {/* Document Uploads */}
                                {/* <FieldArray
                                    name="uploadedFile"
                                    render={(arrayHelpers) => (
                                        <>
                                            {values.uploadedFile && values.uploadedFile.length > 0 ? (
                                                values.uploadedFile.map((file, index) => (
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        key={index}
                                                        alignItems="center"
                                                    >
                                                        <Grid item md={12} xs={12}>
                                                            <Box
                                                                sx={{
                                                                    border: "1px solid grey",
                                                                    borderRadius: "8px",
                                                                    p: 2,
                                                                    marginBottom: 2,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="h6"
                                                                    gutterBottom
                                                                    align="left"
                                                                    sx={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    Upload Document {index + 1}
                                                                    <Chip
                                                                        label="Optional"
                                                                        color="primary"
                                                                        size="small"
                                                                        sx={{ ml: 1, fontSize: '0.7rem', height: '20px' }}
                                                                    />
                                                                </Typography>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(event) => handleFileUpload(event, index)}
                                                                />
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{ display: 'block', mt: 1 }}
                                                                >
                                                                    Only image files (JPEG, PNG, GIF, WebP) are allowed
                                                                </Typography>
                                                                {file && (
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="textSecondary"
                                                                    >
                                                                        {file.name}
                                                                    </Typography>
                                                                )}
                                                                {previews.uploadedFile[index] && (
                                                                    <Box sx={{ position: "relative", display: "inline-block" }}>
                                                                        <img
                                                                            src={previews.uploadedFile[index]}
                                                                            alt={`Preview ${index + 1}`}
                                                                            style={{
                                                                                width: "100%",
                                                                                maxWidth: "200px",
                                                                                marginTop: "10px",
                                                                                borderRadius: "4px",
                                                                                border: "1px solid #ccc",
                                                                            }}
                                                                        />
                                                                        <IconButton
                                                                            aria-label="delete"
                                                                            onClick={() => handleRemoveFilePreview(index)}
                                                                            sx={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                right: 0,
                                                                                background: "#fff",
                                                                                zIndex: 2,
                                                                            }}
                                                                        >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Box>
                                                                )}
                                                                <ErrorMessage
                                                                    name={`uploadedFile[${index}]`}
                                                                    component="div"
                                                                    style={{
                                                                        color: "red",
                                                                        marginTop: "8px",
                                                                    }}
                                                                />
                                                                {errorTexts[index] && (
                                                                    <Typography variant="body2" color="error">
                                                                        {errorTexts[index]}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            ) : (
                                                <Grid container spacing={2}>
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        sx={{ paddingLeft: 2 }}
                                                    >
                                                        No files uploaded yet.
                                                    </Typography>
                                                </Grid>
                                            )}
                                            <Grid container spacing={2} justifyContent="flex-end">
                                                <IconButton
                                                    className="addFieldBtn"
                                                    aria-label="add"
                                                    onClick={() => arrayHelpers.push(null)}
                                                    sx={{ padding: 0 }}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </Grid>
                                        </>
                                    )}
                                /> */}

                                {/* Signature Upload */}
                                <Grid item xs={12} md={12} sx={{ mt: 3 }}>
                                    <Box
                                        sx={{ border: "1px solid grey", borderRadius: "8px", p: 2 }}
                                    >
                                        <Typography 
                                            variant="h6" 
                                            gutterBottom 
                                            align="left"
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            Upload Signature
                                            <Chip
                                                label="Optional"
                                                color="primary"
                                                size="small"
                                                sx={{ ml: 1, fontSize: '0.7rem', height: '20px' }}
                                            />
                                        </Typography>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleSignatureUpload}
                                        />
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: 'block', mt: 1 }}
                                        >
                                            Only image files (JPEG, PNG, GIF, WebP) are allowed
                                        </Typography>
                                        {values.signature && (
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                                sx={{ mt: 1 }}
                                            >
                                                {typeof values.signature === 'string' ? values.signature.split('/').pop() : values.signature.name}
                                            </Typography>
                                        )}
                                        {previews.signature && (
                                            <Box sx={{ position: "relative", display: "inline-block" }}>
                                                <img
                                                    src={previews.signature}
                                                    alt="Signature Preview"
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "200px",
                                                        marginTop: "10px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #ccc",
                                                    }}
                                                />
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={handleRemoveSignature}
                                                    sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        right: 0,
                                                        background: "#fff",
                                                        zIndex: 2,
                                                    }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        )}
                                        <ErrorMessage
                                            name="signature"
                                            component="div"
                                            style={{ color: "red", marginTop: "8px" }}
                                        />
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </>
    );
}
